import { vehicleTypeTabLabels } from './VehicleConstants';

export const validateVIN = (value) => {
  const error = value && value?.length > 0 && value.indexOf('_') !== -1;
  return error ? 'Should be 17 characters' : undefined;
};

export const getInitialVehicleTab = (availableTabs, defaultTab) => {
  if (availableTabs?.length) {
    if (availableTabs.includes(defaultTab)) {
      return defaultTab;
    }
    const firstValidAvailableTab = availableTabs.find(
      (tab) => vehicleTypeTabLabels[tab],
    );
    if (firstValidAvailableTab) {
      return firstValidAvailableTab;
    }
  }
  return 'year';
};

// Maps all valid available tabs from z3p config to labels
export const getTabNames = (availableVehicleEntryTabs, isUsingHeavyDuty) => {
  const tabToLabelMap = availableVehicleEntryTabs.reduce((map, tab) => {
    const tabMap = map;
    if (tab === 'heavy') {
      // Don't show heavy duty tab if is_using_heavy_duty is false, even if 'heavy' is an available tab
      if (isUsingHeavyDuty) {
        tabMap[tab] = vehicleTypeTabLabels[tab];
      }
    } else {
      tabMap[tab] = vehicleTypeTabLabels[tab];
    }
    return tabMap;
  }, {});
  if (!Object.values(tabToLabelMap).filter(Boolean).length) {
    return { year: 'Year, Make, Model, Trim' };
  }
  return tabToLabelMap;
};

export const restructureVehicleData = (vehicle) => {
  if (!vehicle) return {};

  const inputMethodType = vehicle.input_method_type;
  if (inputMethodType === 'year') {
    return {
      year: vehicle.year,
      make: vehicle.make,
      model: vehicle.model,
      color: vehicle.color,
      trim: vehicle.trim,
    };
  }

  if (inputMethodType === 'license') {
    return {
      license_plate_number: vehicle.license_plate_number,
      license_plate_state: vehicle.license_plate_state,
      color: vehicle.color,
    };
  }

  if (inputMethodType === 'vin') {
    return {
      vin: vehicle.vin,
      color: vehicle.color,
    };
  }

  return {
    year: vehicle.year,
    make: vehicle.make,
    model: vehicle.model,
    color: vehicle.color,
  };
};
